// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const Booth: React.FunctionComponent<any> = (props) => {
    return (
        <SvgIcon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <g fill="rgba(255,255,255,.8)">
                    <path d="M15.8584,16 C15.4124,14.277 13.8614,13 12.0004,13 C10.1384,13 8.5874,14.277 8.1414,16 L4.0004,16 L4.0004,4 C4.0004,5.104 4.8954,6 6.0004,6 C7.1044,6 8.0004,5.104 8.0004,4 C8.0004,5.104 8.8954,6 10.0004,6 C11.1044,6 12.0004,5.104 12.0004,4 C12.0004,5.104 12.8954,6 14.0004,6 C15.1044,6 16.0004,5.104 16.0004,4 C16.0004,5.104 16.8954,6 18.0004,6 C19.1044,6 20.0004,5.104 20.0004,4 L20.0004,16 L15.8584,16 Z M20.5864,0 L3.4144,0 C3.1494,0 2.8944,0.105 2.7074,0.293 L0.0004,3 L0.0004,3.857 C0.0004,4.833 0.6354,5.752 1.5894,5.956 C2.1134,6.068 2.5974,5.957 3.0004,5.723 L3.0004,16 L2.0004,16 C1.4474,16 1.0004,16.447 1.0004,17 L1.0004,23 C1.0004,23.553 1.4474,24 2.0004,24 L22.0004,24 C22.5524,24 23.0004,23.553 23.0004,23 L23.0004,17 C23.0004,16.447 22.5524,16 22.0004,16 L21.0004,16 L21.0004,5.723 C21.4024,5.957 21.8864,6.068 22.4104,5.956 C23.3654,5.752 24.0004,4.833 24.0004,3.857 L24.0004,3 L21.2934,0.293 C21.1054,0.105 20.8504,0 20.5864,0 L20.5864,0 Z"></path>
                    <path
                        d="M12,8 C10.896,8 10,8.896 10,10 C10,11.104 10.896,12 12,12 C13.104,12 14,11.104 14,10 C14,8.896 13.104,8 12,8"
                        id="Fill-4"
                    ></path>
                </g>
            </g>
        </SvgIcon>
    );
};
